import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia, Divider, IconButton, Button } from '@mui/material/';
import {useStyles} from './styles';
import {Visibility} from '@mui/icons-material';
import ModalImage from 'components/ImageModal';
import EditIcon from '@mui/icons-material/Edit';
function Card64Image(props) {
    const classes = useStyles(props),
    [verImagen, setVerImagen] = useState(false),
    [datosImagen, setDatosImagen] = useState({image:'', title:'',});
    const VerImagen = async (datosImagen) => {

        if(props.getDocumentOfPoliticalOrganization) {
            const data = await props.getDocumentOfPoliticalOrganization(datosImagen.documentName);
            if(data) {
                setDatosImagen({image: data?.pdf, title: datosImagen?.title})
                setVerImagen(true)
            }
        } else {
            if(!datosImagen?.image) return null;
            setDatosImagen({image: datosImagen?.image, title: datosImagen?.title})
            setVerImagen(true)
        }
    }

    const CerrarVerImagen =()=>{
        setVerImagen(false)
    }

    return (
        <div>
            <Grid container className={classes.rootGrid} justifyContent="center" >
                <Grid item  className={classes.itemGrid}>
                    <Card className={classes.rootCard}>
                        <CardActionArea>
                            <div className={classes.contentMedia}>
                            <CardMedia
                                className={classes.media}
                                alt="image"
                                image={props.image ? props.image.includes('base64,') ? props.image : `data:image/jpeg;base64,${props.image}` : props.src}
                                title={props.title}
                            />
                            </div>
                            <CardContent  className={classes.cardContent}>
                            {props.showTitle && (
                                <Grid item xs={12}>
                                    <div className={classes.centerTitle}><Divider /> <strong>{props.label}</strong> <Divider /></div>
                                </Grid >
                            )}
                            </CardContent>
                        </CardActionArea>
                        <IconButton size={"medium"} className={classes.iconVisibility} onClick={()=>VerImagen({image: props.image, documentName: props.documentName})}><Visibility  style={{ fontSize: 30 }} /></IconButton>
                    </Card>
                    {props.showTitle2 && (
                    <CardContent  className={classes.cardContent}>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle2}><Divider /> <strong >{props.title}</strong> <Divider /></div>
                        </Grid >
                        {props.showButtonEditDocument && (
                            <Button variant="contained" color="primary" className={classes.button} onClick={() => props.handleClickUpdateDocument(props)}>
                                {props.iconButton}
                                {props.firstTitle} {props.title}
                            </Button>
                        )}
                    </CardContent>
                    )}
                </Grid>
                <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen} showDownloadButton={props.showDownloadButton} src={props.src} />
            </Grid>
        </div>
    );
}

Card64Image.propsDefault = {
    src: "/menu/plan_de_medios_alternativos.png",
    showTitle : true,
    showButtonEditDocument: false,
    firstTitle: "Actualizar ",
    handleClickUpdateDocument: () => {},
    iconButton : <EditIcon />
}
export default Card64Image;